import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../actions/userActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import FormContainer from "../components/FormContainer";

const LoginScreen = ({ location, history }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { loading, error, userInfo } = userLogin;

  const redirect = location.search
    ? location.search.split("=")[1]
    : "/dashboard";

  useEffect(() => {
    if (userInfo) {
      history.push(redirect);
    }
  }, [history, userInfo, redirect]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(login(email, password));
  };

  return (
    <>
      <div className="tw-flex tw-justify-center tw-my-16">
        <p className="tw-font-nunito sm:tw-text-4xl tw-text-xl tw-font-bold">
          VIDYUT RAKSHAK
        </p>
      </div>
      <div className="tw-w-3/4 md:tw-w-1/2 tw-mt-16 tw-mx-auto tw-flex tw-justify-center tw-items-center tw-p-1 tw-border-1 tw-rounded-lg tw-shadow-2xl">
        <FormContainer>
          {/* <h3 className="tw-font-nunito sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center tw-my-4">
            Sign In
          </h3> */}
          {error && <Message variant="danger">{error}</Message>}
          {loading && <Loader />}
          <Form onSubmit={submitHandler} className="tw-font-nunito tw-mt-8">
            <Form.Group className="tw-py-2" controlId="email">
              <Form.Label>Email ID</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="tw-py-2" controlId="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <br />
            <Button
              type="submit"
              className="tw-mb-8 tw-px-16 tw-block tw-mx-auto tw-transition tw-duration-700 tw-ease-in-out tw-transform hover:-tw-translate-y-1 hover:tw-scale-11 myButton"
            >
              Sign In
            </Button>
          </Form>
        </FormContainer>
      </div>
    </>
  );
};

export default LoginScreen;
